/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientDetailsResponseViewModel } from './ClientDetailsResponseViewModel';
import {
    ClientDetailsResponseViewModelFromJSON,
    ClientDetailsResponseViewModelFromJSONTyped,
    ClientDetailsResponseViewModelToJSON,
} from './ClientDetailsResponseViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfClientDetailsResponseViewModel
 */
export interface ResultOfClientDetailsResponseViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ClientDetailsResponseViewModel}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    data?: ClientDetailsResponseViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfClientDetailsResponseViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfClientDetailsResponseViewModel interface.
 */
export function instanceOfResultOfClientDetailsResponseViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfClientDetailsResponseViewModelFromJSON(json: any): ResultOfClientDetailsResponseViewModel {
    return ResultOfClientDetailsResponseViewModelFromJSONTyped(json, false);
}

export function ResultOfClientDetailsResponseViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfClientDetailsResponseViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ClientDetailsResponseViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfClientDetailsResponseViewModelToJSON(value?: ResultOfClientDetailsResponseViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ClientDetailsResponseViewModelToJSON(value.data),
        'Count': value.count,
    };
}

